import type { PresentationStyle } from 'paintscout'

/**
 * Fallback style for a presentation with no `advanced.style` saved yet.
 *
 * Lives on its own so both getPresentationTheme (content CSS) and
 * getPresentationButtonColors (nav / quick cart CTAs) can read it without an import cycle.
 */
export const defaultPresentationStyle: PresentationStyle = {
  accentColor: '#000000',
  backgroundColor: '#FFFFFF',
  buttonColor: '#000000',
  textColor: '#000000',
  fontFamily: 'roboto, sans-serif',
  heading1: {},
  heading2: {},
  heading3: {},
  body: {}
}
